import { Menu } from '@/services/manageService/menuService';

/**
 * 扁平化所有按钮权限（menuType=3）的 realm 字段
 */
export function getAllButtonRealms(menuTree: Menu[]): string[] {
  const result: string[] = [];
  function traverse(menus: Menu[]) {
    menus.forEach(menu => {
      if (menu.menuType === 3 && menu.realm) {
        result.push(menu.realm);
      }
      if (menu.children && menu.children.length > 0) {
        traverse(menu.children);
      }
    });
  }
  traverse(menuTree);
  return result;
}

/**
 * 判断用户是否有某按钮权限
 */
export function hasButtonPermission(menuTree: Menu[], realm: string): boolean {
  function find(menus: Menu[]): boolean {
    for (const menu of menus) {
      if (menu.menuType === 3 && menu.realm === realm) return true;
      if (menu.children && menu.children.length > 0) {
        if (find(menu.children)) return true;
      }
    }
    return false;
  }
  return find(menuTree);
}

/**
 * 递归生成菜单栏用的树结构（只保留 menuType=1,2）
 */
export function filterMenuForSidebar(menuTree: Menu[]): Menu[] {
  if (!Array.isArray(menuTree)) return [];
  function sortMenus(menus: Menu[]): Menu[] {
    return [...menus].sort((a, b) => {
      const aSort = a.sort ?? Number.MAX_SAFE_INTEGER;
      const bSort = b.sort ?? Number.MAX_SAFE_INTEGER;
      if (aSort !== bSort) return aSort - bSort;
      return a.menuId - b.menuId;
    });
  }
  function filterMenus(menus: Menu[]): Menu[] {
    if (!Array.isArray(menus)) return [];
    return sortMenus(menus)
      .filter(menu => menu.menuType === 1 || menu.menuType === 2)
      .map(menu => ({
        ...menu,
        children: menu.children ? filterMenus(menu.children) : [],
      }));
  }
  return filterMenus(menuTree);
}
